export const colors = [
      // 🌊 Tonos de Azul (Principal)
      '#f7931a55', '#1E6FEC55', '#005EFF55', '#6699FF55', '#8AB6FF55',
      '#4169E155', '#5B82E655', '#6CA6CD55', '#89CFF055', '#B0C4DE55',
    
      // 🎨 Tonos Complementarios (Contraste Suave)
      '#FA854B55', '#EC6F1E55', '#FF8C0055', '#FFA07A55', '#FF450055',
      '#FF573355', '#D9534F55', '#FF696155', '#FF967155', '#FFB99755',
    
      // 💜 Tonos Análogos (Armonía con el Azul)
      '#8A2BE255', '#9370DB55', '#BA55D355', '#DDA0DD55', '#D8BFD855',
      '#6A5ACD55', '#7B68EE55', '#B19CD955', '#BC8F8F55', '#C39BD355',
    
      // 🌿 Tonos Naturales (Frescura & Modernidad)
      '#32CD9955', '#20B2AA55', '#008B8B55', '#66CDAA55', '#3CB37155',
      '#228B2255', '#9ACD3255', '#ADFF2F55', '#B3D9A555', '#C4E17F55',
    
      // 🌅 Tonos Pastel (Suaves & Elegantes)
      '#FFDAB955', '#FFE4B555', '#FAFAD255', '#FFFACD55', '#E6E6FA55',
      '#F5F5DC55', '#F0E68C55', '#F8C8DC55', '#FFCCCB55', '#FFE5E555',
    
      // 🎭 Tonos Neutros & Oscuros (Para UI Elegante)
      '#F0F8FF55', '#EAEAEA55', '#D3D3D355', '#C0C0C055', '#A9A9A955',
      '#FFFFFF', '#69696955', '#50505055', '#30303055', '#1A1A1A55'
    ];
    
    export const colorsBorder = [
      // 🌊 Tonos de Azul (Principal)
      '#f7931a', '#1E6FEC', '#005EFF', '#6699FF', '#8AB6FF',
      '#4169E1', '#5B82E6', '#6CA6CD', '#89CFF0', '#B0C4DE',
    
      // 🎨 Tonos Complementarios (Contraste Suave)
      '#FA854B', '#EC6F1E', '#FF8C00', '#FFA07A', '#FF4500',
      '#FF5733', '#D9534F', '#FF6961', '#FF9671', '#FFB997',
    
      // 💜 Tonos Análogos (Armonía con el Azul)
      '#8A2BE2', '#9370DB', '#BA55D3', '#DDA0DD', '#D8BFD8',
      '#6A5ACD', '#7B68EE', '#B19CD9', '#BC8F8F', '#C39BD3',
    
      // 🌿 Tonos Naturales (Frescura & Modernidad)
      '#32CD99', '#20B2AA', '#008B8B', '#66CDAA', '#3CB371',
      '#228B22', '#9ACD32', '#ADFF2F', '#B3D9A5', '#C4E17F',
    
      // 🌅 Tonos Pastel (Suaves & Elegantes)
      '#FFDAB9', '#FFE4B5', '#FAFAD2', '#FFFACD', '#E6E6FA',
      '#F5F5DC', '#F0E68C', '#F8C8DC', '#FFCCCB', '#FFE5E5',
    
      // 🎭 Tonos Neutros & Oscuros (Para UI Elegante)
      '#F0F8FF', '#EAEAEA', '#D3D3D3', '#C0C0C0', '#A9A9A9',
      '#FFFFFF', '#696969', '#505050', '#303030', '#1A1A1A'
    ];
    